import { useMutation, useQueryClient } from "react-query";

import { httpService } from "utils";

import { useGetAuthorizationStore } from "../../authentication/infrastructure/useGetAuthorizationStore";

export const useCancelUserAppointment = () => {
  const { userId } = useGetAuthorizationStore((state) => ({
    userId: state.userId,
  }));
  const queryClient = useQueryClient();

  if (!userId) {
    throw new Error("UserId not found");
  }

  return useMutation((appointmentId: string) => {
    return cancelUserAppointment(appointmentId, userId).then(async (res) => {
      await queryClient.invalidateQueries("user-appointments");
      return res;
    });
  });
};

const cancelUserAppointment = (appointmentId: string, userId: string) => {
  return httpService().post(
    `/e-reservation/user/${userId}/appointment/${appointmentId}/cancel`
  );
};
